var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Checkbox',{attrs:{"label":_vm.Strings['Shop.CheckboxNewsletter'],"value":_vm.CurrentTransaction.wantsNewsletter},on:{"change":function($event){return _vm.updateWantsNewsletter($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }